import { useProjectContext } from "@contexts/projects";

export const formatExtraValueCents = (
  cents,
  { cubBased = false, indexerValue = null } = {},
) => {
  const reais = cents / 100;
  if (cubBased) {
    const divisor = Number(indexerValue) || 1;
    return `${(reais / divisor).toLocaleString("pt-BR", {
      maximumFractionDigits: 2,
    })} CUB`;
  }
  return reais.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const ExtraValuesSummary = ({ summary, loading, loadError }) => {
  const { cubBased, activeProject } = useProjectContext();
  const format = (cents) =>
    formatExtraValueCents(cents, {
      cubBased,
      indexerValue: activeProject?.indexer?.value,
    });
  if (loading) return <p role="status">Carregando visão geral…</p>;
  if (loadError || summary.error) {
    return (
      <p className="alert alert-error" role="alert">
        {loadError ?? summary.error.message}
      </p>
    );
  }
  const cards = [
    ["Estouros", format(summary.expensesCents), "expense"],
    ["Economias", format(summary.savingsCents), "saving"],
    ["Saldo líquido", format(summary.netCents), "balance"],
    ["Alvos ativos", summary.activeTargetCount.toLocaleString("pt-BR"), "targets"],
  ];
  return (
    <div className="extra-values-summary-grid">
      {cards.map(([label, value, tone]) => (
        <article
          className={`extra-values-summary-card extra-values-summary-card--${tone}`}
          key={label}
        >
          <span>{label}</span>
          <strong>{value}</strong>
        </article>
      ))}
    </div>
  );
};

export default ExtraValuesSummary;
